import { useContext } from 'react';
import Skeleton from '@/vdp/HeroVehicleInfo/Skeleton';
import GlobalContext from '~/context/vdp/GlobalContext';
import { useIsInHeroRefreshTreatment } from '~/hooks/vdp';
import Star from '~/icons/Star';

export default function StarRating() {
  const {
    vehicleRating: {
      isLoaded,
      data: { averageRating, totalRatingCounts }
    }
  } = useContext(GlobalContext);

  const isInHeroRefreshTreatment = useIsInHeroRefreshTreatment();

  if (!isInHeroRefreshTreatment) return null;

  if (!isLoaded) return <Skeleton width={140} />;

  return averageRating ? (
    <div className="flex h-24 items-center gap-x-4 text-blue-6">
      <Star className="w-20 fill-yellow-2" />
      <span className="font-semibold">
        {averageRating.toLocaleString(undefined, {
          minimumFractionDigits: 1
        })}
      </span>
      <a
        href="#owner-reviews"
        className="underline"
        data-analytics-id="Hero"
        data-analytics-attributes={JSON.stringify({
          description: 'Owner Reviews'
        })}
      >
        {totalRatingCounts.toLocaleString()} reviews
      </a>
    </div>
  ) : null;
}
